import React from "react";

// Read-only display for a formula column. The cached numeric value comes
// from the backend on every related cell write. To edit the expression
// itself, edit the column (not the cell).
export default function FormulaCell({ value, column }) {
  if (value === null || value === undefined) {
    return (
      <div
        className="cell-display formula read-only"
        title={column?.settings?.expression || "Set an expression on this column"}
      >
        <span className="placeholder">—</span>
      </div>
    );
  }
  const decimals = Number.isInteger(value) ? 0 : 2;
  return (
    <div
      className="cell-display formula read-only"
      title={`= ${column?.settings?.expression || ""}`}
    >
      <span className="formula-eq">ƒ</span>
      <span>{Number(value).toFixed(decimals)}</span>
    </div>
  );
}
